import clsx from 'clsx';
import { DownloadFieldsFragment } from 'api/graphql-types';

import { Icon } from 'components/icon/icon';
import { Button } from 'components/button';
import { Typography } from 'components/typography';

import IcnChevronRight from 'public/assets/icons/chevron-right.svg';

import styles from './downloads.module.scss';

export interface IDownloadsProps {
	module: DownloadFieldsFragment;
}

const Downloads = (props: IDownloadsProps): React.JSX.Element => {
	const darkStyling = props.module.defaultModuleOptions?.extendedBackgroundColor === 'darkblue';

	return (
		<div className={clsx(styles.downloads, darkStyling && styles.dark)}>
			{props.module.downloadsTitle?.value && (
				<Typography tag={props.module.downloadsTitle?.type || 'h2'} variant="h2">
					{props.module.downloadsTitle.value}
				</Typography>
			)}
			<div className={styles.items}>
				{props.module.downloads?.map((download, index) => (
					<div className={clsx(styles.darkItem, darkStyling && styles.lightItem)} key={`${index}-file`}>
						{downloadComponent(
							renderDownloadLink(
								{
									ext: download?.data?.attributes?.ext || '',
									size: download?.data?.attributes?.size || 0
								},
								download?.data?.attributes?.name
							),
							download?.data?.attributes?.url || '/',
							true
						)}
						{download?.data?.attributes?.caption && (
							<span id="description" className={styles.label}>
								{download?.data?.attributes?.caption}
							</span>
						)}
					</div>
				))}
				{props.module.downloadLinks?.map((downloadLink, index) => (
					<div className={clsx(styles.darkItem, darkStyling && styles.lightItem)} key={`${index}-link`}>
						{downloadComponent(
							downloadLink.title || downloadLink?.href?.text || downloadLink?.href?.linkText || '',
							downloadLink?.href?.url || downloadLink?.href?.linkUrl || '/',
							downloadLink?.href?.linkType === 'external' || false
						)}
						{downloadLink?.description && (
							<span id="description" className={styles.label}>
								{downloadLink?.description}
							</span>
						)}
					</div>
				))}
			</div>
		</div>
	);
};

const downloadComponent = (title: string, url: string, isExternalLink: boolean): React.JSX.Element => {
	return (
		<Button
			title={title}
			variant="tertiary-dark"
			icon={<Icon customIcon={<IcnChevronRight />} size="12px" />}
			iconPosition="left"
			href={url}
			isExternalLink={isExternalLink}
		/>
	);
};

export const renderDownloadLink = (file: { ext: string; size: number }, name?: string): string => {
	const nameWithoutExt = name ? name.replace(/\.[^./]+$/, '').replaceAll(/-|_/g, ' ') : name ?? '';
	return `${nameWithoutExt} ${
		file?.ext
			? `(${file.ext.slice(1, file.ext.length).toUpperCase()}${
					file.size ? `, ${(file.size / 1000).toFixed(2)} MB` : ''
			  })`
			: ``
	} `;
};

export default Downloads;
